function extractDateTime(input) {
    if (!input) return { date: '', time: '' };
    const formattedInput = input?.replace('&nbsp;', ' ');

    const [date, time] = formattedInput?.split(' ');
    return {
        date: date,           
        time: time,          
    };
}


export {extractDateTime}